export class PersonUtils {
  public static getFirstName = (fullName?: string): string => {
    if (!fullName) return ''

    if (fullName.includes(' ')) return fullName.split(' ')[0]

    return fullName
  }
}
